module.exports = "app-stadium-camera-360.normal {\n  height: calc(100vh - 6.25rem);\n  display: block; }\n\napp-stadium-camera-360.fullScreen {\n  height: 100vh;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/stadium/stadium.component.scss
// module id = ./src/app/views/stadium/stadium.component.scss
// module chunks = main